import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ApontamentoProducao } from '../../types/producao';
import {
  apontamentosProducaoService,
  maquinasService,
  operadoresService,
  ordensProducaoService,
} from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<ApontamentoProducao>[] = [
  {
    name: 'ordem',
    label: 'Ordem de produção',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      ordensProducaoService.list,
      (item: any) => item.codigo ?? String(item.id),
    ),
    required: true,
  },
  {
    name: 'maquina',
    label: 'Máquina',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(maquinasService.list, (item: any) => item.nome ?? String(item.id)),
    required: true,
  },
  {
    name: 'operador',
    label: 'Operador',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      operadoresService.list,
      (item: any) => item.nome ?? String(item.id),
    ),
    required: true,
  },
  { name: 'data_inicio', label: 'Início', type: 'date', required: true },
  { name: 'data_fim', label: 'Fim', type: 'date' },
  { name: 'quantidade_produzida', label: 'Qtd produzida', type: 'number' },
  { name: 'quantidade_refugada', label: 'Qtd refugada', type: 'number' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const ApontamentosProducaoFormPage: React.FC = () => (
  <ResourceFormPage
    title="Apontamento de produção"
    description="Registre a produção realizada."
    fields={fields}
    service={apontamentosProducaoService}
    redirectPath="/admin/producao/apontamentos-producao"
    cancelPath="/admin/producao/apontamentos-producao"
  />
);
